module.exports = __webpack_public_path__ + "static/image-19-9030c9ba9934878611705df55db3c110.png";